let currentTotalPrice = cartTotalPrice; // this is from cart-template-v2

/**
 * Update cart item quantity or add product to cart
 * - the format must be [item.key]: quantity
 *
 * @param {Object} data
 * @returns cart.json
 */
async function updateProductQuantity(data) {
	try {
		const request = {
			updates: { ...data },
		};
		// not sure why window.Shopify.routes.root doesn't work...
		const response = await fetch(window.location.origin + "/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(request),
		});
		const responseData = await response.json();
		return responseData;
	} catch (error) {
		console.error(error);
	}
}

/**
 * Update cart icon item quantity
 */
function updateCartIconItemQuantity(quantity) {
	const cartIconQuantityElement = document.querySelectorAll("span.cart_count");
	cartIconQuantityElement.forEach((el) => {
		el.innerHTML = quantity;
	});
}

/**
 * Feature: remove cart item
 *
 * @param {string} key The id to remove cart item element
 *
 * - remove item element when user click trash icon
 * - remove item element when item quantity is zero
 */
async function removeCartItemElement(key) {
	// remove desktop item
	const desktopCartItemElement = document.querySelector(`tr[data-key="${key}"]`);
	desktopCartItemElement.remove();
	// remove mobile item
	const mobileCartItemElement = document.querySelector(`.cart-item-container[data-key='${key}']`);
	mobileCartItemElement.remove();

	// update has no saturdays product item property
	const getAllNoSaturdayProduct = document.querySelectorAll(".no-saturdays");
	if (getAllNoSaturdayProduct.length === 0) {
		deliveryDetailData.noSaturdayDelivery = false;
      
	}

	// update has no sundays product item property
	const getAllNoSundayProduct = document.querySelectorAll(".no-sundays");
	if (getAllNoSundayProduct.length === 0) {
		deliveryDetailData.noSundayDelivery = false;
	}

	if ($("#deliveryCity").val()) initDatePicker();

	const cartItemsMobile = document.querySelectorAll(".cart-item-container");
	const cartItemsDesktop = document.querySelectorAll("tbody tr");

	if (cartItemsDesktop.length === 0 || cartItemsMobile.length === 0) {
		location.reload();
	}
  
}

/**
 * Feature: update total price**
 *
 * - when item change quantity
 * - when addons are selected
 * - need to update both mobile and desktop total price display
 */
async function updateCartTotalPrice(input) {
	try {
		$(".cart-item-quantity-box button").attr("disabled", true);
		const cartItemKey = input.currentTarget.id;
		const newQuantity = input.currentTarget.valueAsNumber;
		const data = {
			[cartItemKey]: newQuantity,
		};
		let totalQuantity = 0;

		const response = await updateProductQuantity(data);
		currentTotalPrice = response.total_price;

		if (response.items.length > 0) {
			response.items.forEach((item) => {
				totalQuantity += item.quantity;
			});
		}

		updateTotalPriceWithAddons();
		updateCartIconItemQuantity(totalQuantity);

		if (newQuantity === 0) {
			removeCartItemElement(cartItemKey);
			reloadDatePicker();
		}

		$(".cart-item-quantity-box button").attr("disabled", false);
	} catch (error) {
		console.log(error);
	}
}

$(".cart-item-quantity-box input.quantity").on("change", updateCartTotalPrice);

$("button#delete-item-button").on("click", function (e) {
	e.preventDefault();
	$(`.cart-item-quantity-box input[data-key="${e.currentTarget.dataset.key}"]`)
		.val(0)
		.trigger("change");
});

/**
 * Feature: update total price when add ons are selected
 *
 * - used in cart mobile and desktop addon liquid file respectively
 */
function updateTotalPriceWithAddons() {
	let grandTotal = 0;
	let addonTotalPrice = 0;
	const totalPriceContainer = document.querySelector("p.cart-total-price span.money");
	const mobileTotalPriceContainer = document.querySelector(".mobile-sticky-checkout button .money");
	const allAddonsSelectedDesktop = document.querySelectorAll(
		".cart-desktop-add-ons .main-pro .sub-pro"
	);
	const allAddonsSelectedMobile = document.querySelectorAll(
		".cart-mobile-add-ons .main-pro .sub-pro"
	);

	if (window.innerWidth >= 1024) {
		allAddonsSelectedDesktop.forEach((addon) => {
			if (addon.classList.contains("selected")) {
				addonTotalPrice += Number(addon.dataset.price);
			}
		});

		// console.log(addonTotalPrice);
	} else {
		allAddonsSelectedMobile.forEach((addon) => {
			if (addon.classList.contains("selected")) {
				addonTotalPrice += Number(addon.dataset.price);
			}
		});

		// console.log(addonTotalPrice);
	}

	grandTotal = (addonTotalPrice + currentTotalPrice) / 100;

	const formatedPrice = new Intl.NumberFormat("en-ID", {
		style: "currency",
		currency: "IDR",
		currencyDisplay: "narrowSymbol",
	}).format(grandTotal);

	totalPriceContainer.innerHTML = formatedPrice;
	mobileTotalPriceContainer.innerHTML = formatedPrice;
}

/**
 * Feature: delivery date and timeslot validation
 *
 * - prevent checkout if there is invalid item
 * - prevent checkout if date & timeslot is not selected
 * - add selected addons to cart
 *      choose which addons carousel to look for by checking the screen width
 */
async function formValidation() {
	const deliveryDateInput = document.querySelector("#order_date");
	const deliveryTimeslotInput = document.querySelector("#order_time");
	const inputList = ["delivery date", "delivery timeslot"];
	const inputValues = [
		deliveryDateInput.value,
		deliveryTimeslotInput.value,
	];
	let errorMsg = "";
	// const cartItemsMobile = document.querySelectorAll(".cart-item-container");
	const cartItemsDesktop = document.querySelectorAll("tbody tr");
	const cartAddonItems = document.querySelectorAll(".cart-item-container.is-addon");

	if (cartItemsDesktop.length === cartAddonItems.length) {
		errorMsg = "Please select at least one non-addon product to proceed to checkout";
		alert(errorMsg);
		// $(".checkout_error").text(errorMsg);
		// $(".checkout_error").show();
		return;
	}

	if (!deliveryDateInput.value || !deliveryTimeslotInput.value) {
		const emptyValues = [];
		inputValues.forEach((value, index) => {
			if (!value) {
				emptyValues.push(inputList[index]);
			}
		});
		errorMsg = `Please complete the following (${emptyValues.toString()}) to proceed.`;
		alert(errorMsg);

		if (!deliveryDateInput.value) {
			$(".date-picker-container").addClass("error");
		}
		if (!deliveryTimeslotInput.value) {
			$(".time-picker-container").addClass("error");
		}

		if (window.innerWidth >= 1024) {
			window.scrollTo(0, 0);
		} else {
			const form = document.querySelector("form#cart_form");
			$(window).scrollTop(form.offsetTop - 175);
		}
		return;
	}

	// add addons to cart
	const selectedAddonsDesktop = document.querySelectorAll(
		".cart-desktop-add-ons .main-pro .sub-pro.selected"
	);
	const selectedAddonsMobile = document.querySelectorAll(
		".cart-mobile-add-ons .main-pro .sub-pro.selected"
	);
	const selectedAddonData = {};
	if (window.innerWidth >= 1024) {
		for (const addon of selectedAddonsDesktop) {
			selectedAddonData[addon.dataset.vid] = 1;
		}
		await updateProductQuantity(selectedAddonData);
	} else {
		for (const addon of selectedAddonsMobile) {
			selectedAddonData[addon.dataset.vid] = 1;
		}
		await updateProductQuantity(selectedAddonData);
	}

	// remove error border
	$(".date-picker-container").removeClass("error");
	$(".time-picker-container").removeClass("error");

	// hide error msg
	$(".checkout_error").hide();
	// click real checkout button
	$(".checkout_original").trigger("click");
}

$("#checkout_clone, .mobile-sticky-checkout button").on("click", async function () {
	await formValidation();
});
